<div class="col-3">
    <label for="scanned-document-type" class="entry-label">typ naskenovaného dokumentu</label>
    <select
        name="scanned-document-type"
        id="scanned-document-type"
        [(ngModel)]="uploadedType"
        (ngModelChange)="onChangeAttachmentType();"
        autofocus
        required>
        <option *ngFor="let uploadedType of attachmentTypesScan" [value]="uploadedType.id">{{uploadedType.name}}</option>
    </select>
</div>

<div class="col-6" *ngIf="owners?.length > 1">
    <div class="scrollable nativeScrollbar inside" style="max-height: 170px">
        <table class="component-tabulatedList verticalAlignMiddle tighter nativeStickyThead" id="test-subjectsScanData">
            <thead>
                <tr>
                    <th class="column-checkbox">
                        <input
                            type="checkbox"
                            name="list-subject-all"
                            [checked]="checkedAll"
                            (click)="toggleCheckAll();"
                            id="list-subject-all" />
                        <label
                            for="list-subject-all"
                            class="showAsCheckbox"
                            title="přidat/odebrat všechny">
                        </label>
                    </th>
                    <th>Propachtovatelé</th>
                </tr>
            </thead>
            <tbody>
                <tr (click)="toggleCheckSubject(subject.id);"
                    class="clickable"
                    *ngFor="let subject of (owners | orderBy: 'id');trackByProperty: 'id'">
                    <td>
                        <input
                            type="checkbox"
                            name="list-subject-{{subject.id}}"
                            value="{{subject.id}}"
                            id="list-subject-{{subject.id}}"
                            (click)="toggleCheckSubject(subject.id);"
                            [checked]="isSubjectChecked(subject.id)">
                        <label
                            for="list-subject-{{subject.id}}"
                            class="showAsCheckbox"
                            title="vybrat/odebrat">
                        </label>
                    </td>
                    <td>
                        <strong>{{subject| displayName}}</strong>
                        &ngsp;
                        <span class="textDescription">{{subject| displayNumber}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>